import type {PayloadAction} from '@reduxjs/toolkit'
import type {SagaIterator} from 'redux-saga'
import {takeLatest, put, call} from 'redux-saga/effects'
import {queryConfigs} from 'data/queryConfigs'
import {standardErrorAction} from 'helpers/saga'
import {queryClient} from 'main'
import {createEntity} from 'store/entity/asyncHelpers'
import type {Person} from 'types/person'
import type {EntityCreateParams} from '../../types'
import {createPersonSuccess} from '../actions'
import {CREATE, CREATE_FAILURE} from '../constants'

export function* createPerson(
  action: PayloadAction<EntityCreateParams<Person>>
): SagaIterator<Person> {
  try {
    const payload = yield call(() =>
      createEntity({
        kind: 'PERSON',
        data: action.payload,
      })
    )
    queryClient.invalidateQueries({queryKey: queryConfigs.people.list.queryKey})
    yield put(createPersonSuccess(payload))
    return payload
  } catch (e: any) {
    yield put(standardErrorAction(CREATE_FAILURE, e))
    throw e
  }
}

export function* createSaga() {
  yield takeLatest(CREATE, createPerson)
}
